import React from "react";
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};
export const programDetailColumns = (self, employees, other) => {
  let columns = [
    {
      title: '类型',
      dataIndex: 'typeStr',
      key: 'typeStr',
      width: 60
    },
    {
      title: '名称',
      dataIndex: 'title',
      key: 'title',
      width: 140
    },
    {
      title: '编号',
      dataIndex: 'code',
      key: 'code',
      width: 80
    },
    {
      title: '有效截止时间',
      dataIndex: 'time',
      key: 'time',
      render: (text, record) => (
        <>{record && record.time ? formatterDate(moment(record.time+':00')) : ''}</>
      ),
      width: 60
    },
    {
      title: '文件格式',
      dataIndex: 'mode',
      key: 'mode',

      width: 60
    },
    {
      title: '支持平台',
      dataIndex: 'supports',
      key: 'supports',
      width: 60
    },
    {
      title: '学习时长(分)',
      dataIndex: 'duration',
      key: 'duration',
      width: 60
    },
    {
      title: '排序',
      dataIndex: 'orderNum',
      key: 'orderNum',
      width: 30
    },
  ];
  return columns;
}
